module.exports = "h2 {\n  text-align: center;\n  text-transform: uppercase;\n  font-size: 4.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/restore-password/restore-password.component.scss
// module id = ./src/app/pages/restore-password/restore-password.component.scss
// module chunks = main